// extracted by mini-css-extract-plugin
module.exports = {"avatar":"CompanyProfileModal_avatar__xY2AM","close":"CompanyProfileModal_close__jjae7"};